<app-nav></app-nav>

<app-home-hero-business id="main"></app-home-hero-business>
<lib-main-theses [lang]="'en'"></lib-main-theses>
<app-about-us-business id="about-us"></app-about-us-business>

<app-publications id="publications"></app-publications>
<app-for-whoom [type]="'business'" id="for_whom"></app-for-whoom>
<!--&lt;!&ndash;<app-reviews></app-reviews>&ndash;&gt;-->

<!--<app-plans [successRoute]="'cs'" (loaded)="onPlansLoaded($event)"></app-plans>-->
<app-faq></app-faq>
<!--<app-not-supported-mobile class="mobile-block"></app-not-supported-mobile>-->
<app-footer></app-footer>
<!--<lib-promo-code-handler [apiUrl]="apiUrl" [userData]="auth.userData"></lib-promo-code-handler>-->
